import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  endpoint = "mails"

  constructor(private http: HttpClient, private router:Router) {
    
  }

  sendMail(to,subject,text, html,cc?,bcc?,attachments?) {
      // remove user from local storage to log user out
      
    const form: any = {to,subject,text, html,cc, bcc, attachments};
      return this.http.post<any>(
        environment.apiUrl + '/' + this.endpoint,
        form
      );
  }

}
